export default __webpack_public_path__ + "static/media/pyschologist.4d63a745.svg";